export const getExistingDocs = (state) => state.existingDocs;

export const ddlDocOptions = (state) => state.ddlDocOptions;

export const loadingDocs = (state) => state.loadingDocs;

export const getFieldFromDocuments = (state) => (field) => state.loadingDocs.filter(x => x.parameter === field)[0];

export const loadingTemplates = (state) => state.loadingTemplates;

export const currentTemplate = (state) => state.currentTemplate;

export const getFieldFromTemplates = (state) => (field) => state.loadingTemplates.filter(x => x.parameter === field)[0];

export const appWasUpdated = (state) => state.appUpdated;
